import { Box, Skeleton } from '@mui/material'
import { createArrayOfNumbers } from '../../../utils/helpers'

const AttachmentDownloaderSkeleton = ({ size = 3 }) => (
  <>
    {createArrayOfNumbers(size).map((item) => (
      <Box
        key={item}
        sx={customStyles.detailsHeader}
      >
        <Box sx={customStyles.attachmendContainer}>
          <Skeleton variant="rounded" sx={customStyles.attachmentIcon} />
          <Box sx={customStyles.fileDetails}>
            <Skeleton variant="text" sx={customStyles.fileName} />
            <Skeleton variant="text" sx={customStyles.fileSize} />
            <Skeleton variant="text" sx={customStyles.fileName} />
          </Box>
        </Box>
        <Skeleton variant="rounded" sx={customStyles.sideButton} />
      </Box>
    ))}
  </>
)
const customStyles = {
  detailsHeader: {
    height: '90px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '10px',
    padding: '10px 20px',
    borderBottomWidth: { xs: '0', sm: '1px' },
    borderBottomStyle: 'solid',
    borderBottomColor: 'grey.200',
    '&:last-of-type': {
      borderBottom: 'none',
    },
  },
  attachmendContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
  },
  fileDetails: {
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: '0', sm: '5px' },
  },
  attachmentIcon: {
    width: { xs: '30px', sm: '35px' },
    height: { xs: '30px', sm: '40px' },
  },
  fileName: {
    width: { xs: '150px', sm: '200px' },
    height: { xs: '20px', sm: '25px' },
  },
  fileSize: {
    width: '50px',
    height: { xs: '20px', sm: '25px' },
  },
  sideButton: {
    width: { xs: '25px', sm: '30px' },
    height: { xs: '25px', sm: '30px' },
  },
}
export default AttachmentDownloaderSkeleton
